import axios from "axios";

const origin = typeof window !== "undefined" ? window.location.origin : "";
const altOrigin = origin.includes("://www.")
  ? origin.replace("://www.", "://")
  : origin.replace("://", "://www.");

const BASES = [...new Set([origin, process.env.REACT_APP_BACKEND_URL, altOrigin].filter(Boolean))];

async function call(method, path, { body, headers, timeout = 15000 } = {}) {
  let lastErr;
  for (const base of BASES) {
    try {
      const res = await axios({ method, url: `${base}/api${path}`, data: body, headers, timeout });
      return res.data;
    } catch (e) {
      const status = e.response?.status;
      // Real API errors (400/401/429...) mean the backend answered — don't retry elsewhere.
      if (status && status !== 404 && status !== 405 && status < 500) throw e;
      lastErr = e;
    }
  }
  throw lastErr;
}

async function upload(path, formData, headers) {
  let lastErr;
  for (const base of BASES) {
    try {
      const res = await axios.post(`${base}/api${path}`, formData, { headers, timeout: 60000 });
      return res.data;
    } catch (e) {
      const status = e.response?.status;
      if (status && status !== 404 && status !== 405 && status < 500) throw e;
      lastErr = e;
    }
  }
  throw lastErr;
}

export const api = {
  get: (path, headers) => call("get", path, { headers }),
  post: (path, body, headers, timeout) =>
    call("post", path, { body, headers, ...(timeout ? { timeout } : {}) }),
  put: (path, body, headers) => call("put", path, { body, headers }),
  patch: (path, body, headers) => call("patch", path, { body, headers }),
  delete: (path, headers) => call("delete", path, { headers }),
  upload,
};
